import React from 'react';
import { Package, MessageCircleHeart, Compass, Users, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: MessageCircleHeart,
  title: 'Seguimiento ilimitado',
  text: 'Tu camino no termina cuando llegan los resultados. A medida que surgen nuevas preguntas o las situaciones cambian, solo respondé. A diferencia de otros, yo no desaparezco.'
}, {
  icon: Compass,
  title: 'Guía para cada área de tu vida',
  text: 'Amor. Relaciones. Trabajo. Familia. Propósito de vida. Decisiones importantes. Tus desafíos no existen aislados, y mi trabajo tampoco.'
}, {
  icon: Users,
  title: 'Confiada por +10,000 clientas',
  text: 'A lo largo de más de 10 años, ayudé a más de 10,000 personas a encontrar claridad cuando se sentían perdidas, respuestas cuando estaban confundidas, y esperanza cuando se sentían completamente estancadas.'
}, {
  icon: CheckCircle2,
  title: 'Satisfacción garantizada',
  text: 'Tu satisfacción es mi prioridad. Si sentís que tu pedido no te dio la claridad que buscabas, contactame dentro de los 30 días y lo resuelvo — sin excusas. En más de 10 años, menos del 0.5% de las clientas necesitó usar esto.'
}];
export function BenefitsSection() {
  return <section className="w-full py-20 px-4 bg-[#111] border-y border-white/5" data-id="element-85">
      <div className="max-w-6xl mx-auto" data-id="element-86">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 sm:gap-16" data-id="element-87">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex flex-col" data-id="element-88">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#D4AF37]/20 to-transparent flex items-center justify-center text-[#D4AF37] mb-6 border border-[#D4AF37]/30" data-id="element-89">
                <benefit.icon className="w-8 h-8" strokeWidth={1.5} data-id="element-90" />
              </div>
              <h3 className="font-playfair text-2xl text-white mb-3" data-id="element-91">
                {benefit.title}
              </h3>
              <p className="font-inter text-gray-400 text-sm sm:text-base leading-relaxed" data-id="element-92">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}